import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import Navbar from 'client/components/Navbar';
import SrLink from 'client/components/SrLink/SrLink';
import BackButton from 'client/components/BackButton';

const SrBuyerSideAgentFormBody = ({
  children,
  onBack,
  showProgressBar,
}) => {
  const location = useLocation();

  return (
    <div className='page-start'>
      <div className='startTouring'>
        {showProgressBar && (
          <div className='progressBarContainer'>
            <div className='progressBar' style={{ width: '40%' }} />
          </div>
        )}
        <Navbar
          redirectLogoTo='/'
          leftButton={
            onBack ? (
              <BackButton
                onClick={onBack}
              />
            ) : (
              <SrLink
                className='link back'
                to={`/get-started${location.search}`}
                restoreScrollPosition
                redirectToLastLocation
              />
            )}
        />
        <div className='stepContainer'>
          {children}
        </div>
      </div>
    </div>
  );
};

SrBuyerSideAgentFormBody.propTypes = {
  children: PropTypes.node.isRequired,
};

SrBuyerSideAgentFormBody.displayName = 'SrBuyerSideAgentFormBody';

export default SrBuyerSideAgentFormBody;
